import { render, staticRenderFns } from "./addNewQuestion.vue?vue&type=template&id=edc65b7e&scoped=true&"
import script from "./addNewQuestion.vue?vue&type=script&lang=ts&"
export * from "./addNewQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./addNewQuestion.vue?vue&type=style&index=0&id=edc65b7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc65b7e",
  null
  
)

export default component.exports